import { Controller } from "@hotwired/stimulus"

// Toggles between a trigger button and an inline form. Used by the
// "Save transcript" UI on the Test tab — the save form would clutter the
// header if always visible, but a modal is overkill for a single text field.
//
//   <div data-controller="inline-form">
//     <button data-action="inline-form#open" data-inline-form-target="trigger">Save</button>
//     <form data-inline-form-target="form" hidden>
//       <input data-inline-form-target="input">
//       <button data-action="inline-form#close" type="button">Cancel</button>
//     </form>
//   </div>
export default class extends Controller {
  static targets = ["trigger", "form", "input"]

  open(event) {
    event.preventDefault()
    if (this.hasTriggerTarget) this.triggerTarget.hidden = true
    if (this.hasFormTarget) this.formTarget.hidden = false
    if (this.hasInputTarget) {
      this.inputTarget.focus()
      this.inputTarget.select()
    }
  }

  close(event) {
    event?.preventDefault()
    if (this.hasFormTarget) this.formTarget.hidden = true
    if (this.hasTriggerTarget) this.triggerTarget.hidden = false
    if (this.hasInputTarget) this.inputTarget.value = ""
  }
}
